import { Q1Value } from 'models/documents';

const formulaResultCalculation = (
  formula: string,
  values: { [key: string]: Q1Value },
  type: number,
  decimal = 2,
): number | boolean | undefined => {
  // Create an array with all needed fields in order to calculate the formula
  const formulaFieldsName = formula.split(/[=+-]/);
  // Create an array with all the operators to use for the calculation of the formula
  const signs = formula.split('').filter((ele) => ele === '-' || ele === '+');
  // Create an array with all the values (numbers) to use for the calculation of the formula
  const formulaValues = formulaFieldsName.map((formulaFieldName) => values[formulaFieldName]);
  const formulaContents: number[] = formulaValues.map((value) => {
    // If the field doesn't exist in the document, treat it as ZERO instead of NULL/undefined
    if (!value || !value.content) {
      return 0;
    }
    const sum = value.content.reduce(
      (accumulator: number, currentElement) =>
        accumulator + parseFloat(currentElement.content.replace(',', '.') || '0'),
      0,
    );
    return sum;
  });
  // I use the operators array and the values array to calculate the formula
  const reducer = (accumulator: number, currentValue: number, i: number) => {
    const sign = signs[i - 1];
    return sign === '-' ? accumulator - currentValue : accumulator + currentValue;
  };
  if (type === 1) {
    const firstElement = formulaContents[0];
    if (firstElement) {
      const newArray = [...formulaContents];
      newArray.shift();
      const result = newArray.reduce(reducer);
      const inputsArray = [...formulaFieldsName];
      inputsArray.shift();
      return Number(result.toFixed(decimal)) === firstElement;
    } else {
      return false;
    }
  }
  if (type === 2) return formulaContents.reduce(reducer);
};

export default {
  formulaResultCalculation,
};
